import { useState, useEffect } from 'react';

export const CONSENT_KEY = 'forge-cookie-consent';

/**
 * Returns the current consent status: 'accepted' | 'rejected' | null
 * Re-renders whenever the user changes their choice (via the custom event).
 */
const useCookieConsent = () => {
  const [consent, setConsent] = useState(
    () => localStorage.getItem(CONSENT_KEY)
  );

  useEffect(() => {
    const handler = () => setConsent(localStorage.getItem(CONSENT_KEY));
    window.addEventListener('forge-consent-change', handler);
    return () => window.removeEventListener('forge-consent-change', handler);
  }, []);

  return consent; // 'accepted' | 'rejected' | null
};

export default useCookieConsent;
